<div class="grid">
  <div class="col-12">
    <div class="mb-5">
      <p-breadcrumb [model]="breadcrumbItems" [home]="home"></p-breadcrumb>
    </div>
  </div>
</div>

<div class="surface-ground px-4 py-5 md:px-6 lg:px-8">
  @if ( entityCounts$ | async; as entityCounts ) {
  <div class="grid">
    <div class="col-12 md:col-Å6 lg:col-4">
      <div class="surface-card shadow-2 p-3 border-round">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-medium mb-3">Clínicas</span>
            <div class="text-900 font-medium text-xl">{{ entityCounts.clinics }}</div>
          </div>
          <div
            class="flex align-items-center justify-content-center bg-primary border-round"
            style="width: 2.5rem; height: 2.5rem"
          >
            <i class="pi pi-fw pi-building text-xl"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-4">
      <div class="surface-card shadow-2 p-3 border-round">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-medium mb-3">Especialistas</span>
            <div class="text-900 font-medium text-xl">{{ entityCounts.specialists }}</div>
          </div>
          <div
            class="flex align-items-center justify-content-center bg-primary border-round"
            style="width: 2.5rem; height: 2.5rem"
          >
            <i class="pi pi-fw pi-users text-xl"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-4">
      <div class="surface-card shadow-2 p-3 border-round">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-medium mb-3">Usuarios</span>
            <div class="text-900 font-medium text-xl">{{ entityCounts.users }}</div>
          </div>
          <div
            class="flex align-items-center justify-content-center bg-primary border-round"
            style="width: 2.5rem; height: 2.5rem"
          >
            <i class="pi pi-fw pi-users text-xl"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
